/*eslint-disable */
import _ from 'lodash'

export function getToken (state) {
  return state.token
}

export function getTokens (state) {
  return state.tokens
}

export function getSearchFilterObj (state) {
  return state.searchFilterObj
}

export function getSearchIndexById(state) {
  return state.searchIndexById
}

export function getAllCredits (state) {
  return state.fullSorted
}

export function getApprovedCredits (state) {
  return state.approvedSorted
}

export function getUnderReviewCredits (state) {
  return state.underReviewSorted
}

export function getDeniedCredits (state) {
  return state.deniedSorted
}

export function getCancelledCredits (state) {
  return state.cancelledSorted
}

export function getFilter (state) {
  return state.filter
}

export function getAllCreditsCurrentPage (state) {
  return state.creditAllCurrentPage
}

export function getUnderCreditsCurrentPage (state) {
  return state.creditUnderCurrentPage
}

export function getApprovedCreditsCurrentPage (state) {
  return state.creditApprovedCurrentPage
}

export function getDeniedCreditsCurrentPage (state) {
  return state.creditDeniedCurrentPage
}

export function getCancelledCreditsCurrentPage (state) {
  return state.creditCancelledCurrentPage
}

export function getPerPage (state) {
  return state.perPage
}

export function creditsFromUpdate(state) {
  return state.creditsFromUpdate;
}



